export let calcSetupFees = (cartItems) => {
    let f = { lines: {}, total: 0 };
    if (!cartItems)
        return f;
    let fees = {};
    //todo, why is this happening twice?
    cartItems.forEach((element) => {
        var _a, _b;
        if (!element)
            return; //sometimes they have been blank?
        let named = ((_a = element.selMaterial) === null || _a === void 0 ? void 0 : _a.Material) + "-" + ((_b = element.selMaterial) === null || _b === void 0 ? void 0 : _b.Thickness);
        if (!fees[named])
            fees[named] = 0;
        fees[named]++;
    });
    cartItems.forEach((element) => {
        var _a, _b;
        if (!element)
            return; //sometimes they have been blank?
        let named = ((_a = element.selMaterial) === null || _a === void 0 ? void 0 : _a.Material) + "-" + ((_b = element.selMaterial) === null || _b === void 0 ? void 0 : _b.Thickness);
        f.lines[element.key] = element.RawSetupFee / fees[named];
    });
    f.total = Object.keys(f.lines).reduce((acc, curr) => Number(f.lines[curr]) + acc, 0);
    return f;
};
